<template>
  <div>
    <div v-if="order.invoice_id" class="alert alert-warning">
      The invoice for this order was already created. You will need to edit
      <a href="">the invoice</a> directly.
    </div>
    <div class="text-right p-4">
      <button class="btn btn-sm btn-primary" @click="save">Save</button>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Code</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Cost Ea.</th>
          <th>Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in activeItems" :key="index">
          <td>
            <select class="form-control form-control-sm" v-model="item.rate_id">
              <option disabled value="">Please select one</option>
              <option
                v-for="rate in rates" :key="rate.id"
                :value="rate.id">{{ rate.name }}</option>
            </select>
          </td>
          <td>
            <input type="text" v-model="item.body" class="form-control form-control-sm" />
          </td>
          <td>
            <input type="number" v-model="item.qty" class="form-control form-control-sm" />
          </td>
          <td>
            <input type="number" v-model="item.cost" class="form-control form-control-sm" />
          </td>
          <td>
            {{ ((item.qty || 0) * (item.cost || 0)).toFixed(2) }}
          </td>
          <td>
            <button class="btn btn-sm btn-link" @click="deleteItem(item)">delete</button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-top">
          <th>
            <button class="btn btn-sm btn-link" @click="addItem">Add Item</button>
          </th>
          <th></th>
          <th colspan="2" class="text-right">TOTAL</th>
          <th>{{ total.toFixed(2) == NaN ? 0.00 : total.toFixed(2)}}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import api from '@/api'
import n from '@/libs/notifications'

export default {
  name: 'billable-tab',
  props: {
    order: Object,
  },

  data() {
    return {
      rates: [],
      items: this.order.billable_activity
    }
  },

  created() {
    api.get('/rates').then(res => {
      this.rates = res.data.rates
    })
  },

  methods: {
    addItem() {
      this.items.push({ deleted: false })
    },

    deleteItem(item) {
      item.deleted = true
    },

    save() {
      api.post(`/inbound-orders/${this.order.id}/billable-activity`, {
        order: { id: this.order.id },
        items: this.items
      }).then(() => n.success('Billable items saved.'))
    },
  },

  computed: {
    activeItems() {
      return this.items.filter(i => !i.deleted)
    },

    total() {
      return this.items.reduce((acc, item) => acc + (item.qty * item.cost), 0)
    }
  }
}
</script>
